import React from 'react';
import {Redirect, Switch} from "react-router-dom";
import {BasePage} from "app/types/PageTypes";

const ReportPage = (props: BasePage) => {
  return (
      <Switch>
        {props.children}
        <Redirect to='/reports/reports-list'/>
      </Switch>
  );
};

export default ReportPage;